export const DEFAULT_VIDEO_CONSTRAINTS: MediaStreamConstraints['video'] = {
  width: 1280,
  height: 720,
  frameRate: 24,
};

// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_INPUT_KEY = 'TwilioVideoApp-selectedAudioInput';
export const SELECTED_AUDIO_OUTPUT_KEY = 'TwilioVideoApp-selectedAudioOutput';
export const SELECTED_VIDEO_INPUT_KEY = 'TwilioVideoApp-selectedVideoInput';
// This is used to store the current background settings in localStorage
export const SELECTED_BACKGROUND_SETTINGS_KEY = 'TwilioVideoApp-selectedBackgroundSettings';
// Used for calling twilio functions
export const TWILIO_FUNCTION_URL = 'https://sandstorm-robin-5218.twil.io';

export const VIDEOBASEURL = '/video-website';

export const USER_DEFAULT_ROOM_KEY = 'TwilioVideoApp-defaultRoomValue';
export const TASK_ID = 'TaskId';

export const MAINTAIN_START = '2021-12-14T08:00';
export const MAINTAIN_END = '2021-12-14T08:15';
export const AWSConfig = {
  s3Bucket: 'connectedmed-videoimaging-prod',
  testDir: '113-TEST',
  uatDir: '213-UAT',
  prodDir: '313-PROD',
  region: 'ap-southeast-2',
};

export const AZURE_APP_CONFIG_CONNECTION_STRING = `Endpoint=https://med-app.azconfig.io;Id=${process.env.AZURE_CONNECT_ID};Secret=${process.env.AZURE_CONNECT_SECRET}`;
